import { Component, input } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'app-no-data-found',
  standalone: true,
  imports: [MatIcon],
  templateUrl: './no-data-found.component.html',
  styleUrl: './no-data-found.component.css'
})
export class NoDataFoundComponent {
  title = input('No Data Found!');
  message = input('');
  icon = input('folder_off');
}
